import React, { useRef, useState } from 'react';

import "assets/scss/billingPortal/modules/reporting/invoiceCommission.scss";
import MonthlyReport from './reportTypes/MonthlyReport';
import MainReport from './reportTypes/MainReport';

export default function InvoiceCommission() {
    const [isMonthlyReportVisible, setIsMonthlyReportVisible] = useState();
    const [selectedSalesPersonMonthly, setSelectedSalesPersonMonthly] = useState();
    const [selectedDate, setSelectedDate] = useState();

    const queries = useRef({});

    return (
        <div>
            <div className={isMonthlyReportVisible? "":"d-none"}>
                <MonthlyReport queries={queries}
                    isMonthlyReportVisible={isMonthlyReportVisible}
                    setIsMonthlyReportVisible={setIsMonthlyReportVisible}
                    selectedSalesPersonMonthly={selectedSalesPersonMonthly}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                />
            </div>

            <div className={isMonthlyReportVisible? "d-none":""}>
                <MainReport queries={queries}
                    setIsMonthlyReportVisible={setIsMonthlyReportVisible}
                    setSelectedSalesPersonMonthly={setSelectedSalesPersonMonthly}
                    selectedSalesPersonMonthly={selectedSalesPersonMonthly}
                    setSelectedDate={setSelectedDate}
                />
            </div>
        </div>
    );
}